"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ITUIServer = /** @class */ (function () {
    function ITUIServer() {
    }
    /**
     * 初始化TUICore
     *
     * @param {TUICoreParams} options 初始化参数
     */
    ITUIServer.init = function (options) { };
    /**
     * TUICore 挂载vue方法
     *
     * @param {Vue} app vue createApp实例
     */
    ITUIServer.prototype.install = function (app) { };
    /**
     * 获取TUICore实例
     *
     */
    ITUIServer.prototype.getInstance = function () { };
    /**
     * TUICore 登录
     *
     * @param {TUICoreLoginParams} options 登录参数
     * @param {string} options.userID 当前用户名
     * @param {string} options.userSig 当前用户名签名
     * @returns {Promise}
     */
    ITUIServer.prototype.login = function (options) {
        return new Promise(function (resolve, reject) {
        });
    };
    /**
     * TUICore 销毁
     */
    ITUIServer.prototype.destroyed = function () { };
    /**
     * 组件挂载
     *
     * @param {string} TUIName  挂载的组件名
     * @param {any} TUIComponent 挂载的组件
     */
    ITUIServer.prototype.component = function (TUIName, TUIComponent) { };
    /**
     * 插件注入
     *
     * @param {any} TUIPlugin 需要挂载模块的服务
     * @param {any} options 需要挂载模块的服务
     */
    ITUIServer.prototype.use = function (TUIPlugin, options) { };
    /**
     * 方法调用
     *
     * @param {string} TUIName 组件名
     * @param {callback} callback 调用的方法
     */
    ITUIServer.prototype.setAwaitFunc = function (TUIName, callback) { };
    /**
     * 设置公共数据
     *
     * @param {object} store  设置全局的数据
     */
    ITUIServer.prototype.setCommonStore = function (store) { };
    /**
     * 挂载组件数据
     *
     * @param {string} TUIName 模块名
     * @param {any} store  挂载的数据
     * @param {callback} updateCallback 更新数据 callback
     */
    ITUIServer.prototype.setComponentStore = function (TUIName, store, updateCallback) { };
    /**
     * 获取 store 数据库
     *
     */
    ITUIServer.prototype.getStore = function () { };
    /**
     * 监听全局数据
     *
     * @param {Array} keys 需要监听的数据key
     * @param {callback} callback 数据变化回调
     */
    ITUIServer.prototype.storeCommonListener = function (keys, callback) { };
    return ITUIServer;
}());
exports.default = ITUIServer;
